import { render, staticRenderFns } from "./RegionProfileCard.vue?vue&type=template&id=00b9aa4d&"
import script from "./RegionProfileCard.vue?vue&type=script&lang=js&"
export * from "./RegionProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./RegionProfileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports